<template>
  <el-progress
    :percentage="progress"
    :color="progressColor"
    :show-text="noCaption"
    class="tw-w-full tw-rounded-full tw-overflow-hidden"
  ></el-progress>
</template>
<script>
import { Progress } from 'element-ui';

export default {
  name: 'progress-bar',
  components: {
    'el-progress': Progress
  },
  props: {
    progress: { required: true },
    noCaption: { default: false, type: Boolean }
  },
  computed: {
    progressColor() {
      if (this.progress <= 40) {
        return '#f1453d';
      }

      if (this.progress > 40 && this.progress < 60) {
        return '#dfba49';
      }

      if (this.progress >= 60) {
        return '#92d047';
      }
    }
  }
};
</script>
